import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-129cc886"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  class: "online-card"
};
const _hoisted_3 = {
  key: 0,
  class: "online-link"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<a href=\"//spoc-ai-teaching-center.zhihuishu.com/l4/tchCalendar\" class=\"new-path goPath\" data-v-129cc886><div class=\"path-tips\" data-v-129cc886><p data-v-129cc886>新版学堂</p><div class=\"btn\" data-v-129cc886> 进入 <img src=\"https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/6512346f748a47269a2f49532138d003.png\" class=\"default\" data-v-129cc886><img src=\"https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/8d618ef7155e432289294906249856d7.png\" class=\"hover\" data-v-129cc886></div></div></a><a href=\"//onlineweb.zhihuishu.com/onlineMuster/teacherIndex\" class=\"old-path goPath\" data-v-129cc886><div class=\"path-tips\" data-v-129cc886><p data-v-129cc886>旧版学堂</p><div class=\"btn\" data-v-129cc886> 进入 <img src=\"https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/6512346f748a47269a2f49532138d003.png\" class=\"default\" data-v-129cc886><img src=\"https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/8d618ef7155e432289294906249856d7.png\" class=\"hover\" data-v-129cc886></div></div></a>", 2);

const _hoisted_6 = [_hoisted_4];
const _hoisted_7 = ["href"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/199a8aa49cd2435996ed328dbbf89d3c.png",
  alt: ""
}, null, -1));

const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "menu-title"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu arrow-icon"
}, null, -1));

const _hoisted_16 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "card-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TipDialog = _resolveComponent("TipDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.zhsRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)) : (_openBlock(), _createElementBlock("a", {
    key: 1,
    href: $props.onlineLink,
    target: "_blank",
    class: "online-link"
  }, _hoisted_9, 8, _hoisted_7))]), $props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.link)
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
      src: item.img,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_13), _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)]), _hoisted_15], 8, _hoisted_11);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.link)
    }, [_createElementVNode("img", {
      src: item.img,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_18), _createElementVNode("span", _hoisted_19, _toDisplayString(item.name), 1)], 8, _hoisted_17);
  }), 128))]))]), _createVNode(_component_TipDialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.showDialog = $event)
  }, null, 8, ["show"])], 64);
}